import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import ax from "./auth/axios";
import { API_ROOT } from "./utils/api-config";
import { connect } from "react-redux";
import { editTimeslot } from "../actions/timeslotAction";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";

class EditTimeslot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: "",
      delivery_window: "",
      available: false,
      number_of_drivers: 0,
      anchors: {},
      deliveries_per_hour: 0,
      out_of_zone_eligible: false,
      special_only: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.props;
    const { timeslot } = this.props;

    this.setState({
      date: timeslot.date,
      delivery_window: timeslot.delivery_window,
      available: timeslot.available,
      out_of_zone_eligible: timeslot.out_of_zone_eligible,
      special_only: timeslot.special_only,
      number_of_drivers: timeslot.number_of_drivers,
      deliveries_per_hour: timeslot.deliveries_per_hour
        ? timeslot.deliveries_per_hour
        : 0,
      anchors: timeslot.anchors,
    });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    formData.append("booking[date]", this.state.date);
    formData.append("booking[delivery_window]", this.state.delivery_window);
    formData.append("booking[available]", this.state.available);
    formData.append("booking[out_of_zone_eligible]", this.state.out_of_zone_eligible);
    formData.append("booking[special_only]", this.state.special_only);
    formData.append("booking[number_of_drivers]", this.state.number_of_drivers);
    this.state.anchors.length > 0 &&
      formData.append("booking[anchors]", "," + this.state.anchors + ",");
    formData.append(
      "booking[deliveries_per_hour]",
      this.state.deliveries_per_hour
    );

    ax.patch(
      `${API_ROOT}/bookings/${this.props.match.params.id}`,
      formData,
      config
    ).then((response) => {
      this.props.editTimeslot(response.data);
    });
  }
  redirect = () => {
    this.props.history.push({ pathname: "/trackers" });
  };
  render() {
    const state = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridDate">
            <Form.Label>Date</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.date}
              name="date"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridWindow">
            <Form.Label>Delivery Window</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.delivery_window}
              name="delivery_window"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col}>
            <Form.Label>Available</Form.Label>
            <Form.Check
              onChange={this.handleInputChange}
              checked={state.available}
              name="available"
            />
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label>Out of zone eligible</Form.Label>
            <Form.Check
              onChange={this.handleInputChange}
              checked={state.out_of_zone_eligible}
              name="out_of_zone_eligible"
            />
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label>Special Only</Form.Label>
            <Form.Check
              onChange={this.handleInputChange}
              checked={state.special_only}
              name="special_only"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridNumberDrivers">
            <Form.Label>Number of drivers</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.number_of_drivers}
              name="number_of_drivers"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group as={Col} controlId={"formGridAnchors"}>
              <Form.Label>Anchors</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.anchors}
                name="anchors"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Row>
              <Form.Group controlid={"formGridDelivPerhour"}>
                <Form.Label>Deliveries Per Hour</Form.Label>
                <Form.Control
                  onChange={this.handleInputChange}
                  value={state.deliveries_per_hour}
                  name="deliveries_per_hour"
                />
              </Form.Group>
            </Form.Row>
          </Col>
        </Form.Row>
        <Button variant="primary" type="submit">
          Edit Timeslot
        </Button>
      </Form>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  editTimeslot: (timeslot) => dispatch(editTimeslot(timeslot)),
});
export default withRouter(connect(null, mapDispatchToProps)(EditTimeslot));
